<template>
	<transition :name="transition">
	<div v-if="show" class="c-modal" @click="e => close(e)">
		<div class="c-modal__container">
			<div class="c-modal__content">
				<slot>Modal Content</slot>
			</div>			
		</div>
	</div>
	</transition>
</template>

<script>
import VueIcon from '@/components/vue-components/vue-icon/VueIcon.vue';

export default {
	name: 'Modal',
	components: {
		VueIcon
	},
	props: {
		show: {
			type: Boolean,
			default: false
		},
		transition: {
			type: String,
			default: "c-modal__transition"
		}
	},
	watch: {
		show: function (newVal, oldVal) {
			if (newVal) {
				document.querySelector('body').classList.add('t-no-scroll');
			}
			else {
				document.querySelector('body').classList.remove('t-no-scroll');
			}
		}
	},
	methods: {
		close: function(e) {
			if (e.target.classList.contains('c-modal')) {
				this.$emit('closeModal');
			}
		}
	}
};
</script>